var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-provider", {
    ref: "validationInput",
    attrs: { name: "baseInputEditValidationProvider", rules: _vm.rules },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var errors = ref.errors
          var valid = ref.valid
          return [
            _c(
              "div",
              {
                staticClass: "input-box",
                class: errors.length > 0 ? "error" : "",
              },
              [
                _c(
                  "div",
                  { staticClass: "form-group form-control" },
                  [
                    _c("upload-image", {
                      attrs: { name: "imageValidation" },
                      model: {
                        value: _vm.displayModel,
                        callback: function ($$v) {
                          _vm.displayModel = $$v
                        },
                        expression: "displayModel",
                      },
                    }),
                    _vm._v(" "),
                    _c("small", { staticClass: "error-text" }, [
                      _vm._v(_vm._s(errors[0])),
                    ]),
                  ],
                  1
                ),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }